import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as FarmActions from '../_actions/farm';
import { Farm } from '../_models';

export interface FarmState extends EntityState<Farm> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Farm> = createEntityAdapter<Farm>();

const initialState: FarmState = adapter.getInitialState({
  loading: false,
  error: null,
});

const farmReducer = createReducer(
  initialState,

  on(FarmActions.loadFarms, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FarmActions.loadFarmsSuccess, (state, { farms }) =>
    adapter.setAll(farms, { ...state, loading: false })
  ),

  on(FarmActions.loadFarmsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FarmActions.addFarmSuccess, (state, { farm }) => adapter.addOne(farm, state)),

  on(FarmActions.updateFarmSuccess, (state, { farm }) => adapter.upsertOne(farm, state)),

  on(FarmActions.deleteFarmSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    FarmActions.addFarmFailure,
    FarmActions.updateFarmFailure,
    FarmActions.deleteFarmFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FarmState | undefined, action: Action) {
  return farmReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
